import { Link } from "react-router-dom";
import { ArrowRight, Calendar, User } from "lucide-react";

const BLOGS = [
  {
    slug: "laparoscopic-surgery-recovery-tips",
    title: "Recovery Tips After Laparoscopic Surgery",
    excerpt: "Learn how to recover quickly and safely after laparoscopic surgery with these expert tips from Dr. Dileep.",
    image: "/images/blog-images/laparoscopic-surgery.webp",
    date: "2025-01-15",
    author: "Dr. Dileep",
  },
  {
    slug: "gallstones-signs-symptoms",
    title: "Gallstones: Signs, Symptoms and When to See a Surgeon",
    excerpt: "Gallstones affect millions of people. Know the warning signs and when laparoscopic removal is the right choice.",
    image: "/images/blog-images/gallstones.webp",
    date: "2025-02-10",
    author: "Dr. Dileep",
  },
  {
    slug: "hernia-myths-facts",
    title: "Hernia Myths vs Facts: What Every Patient Should Know",
    excerpt: "There are many misconceptions about hernia surgery. Dr. Dileep clears up the most common myths patients ask about.",
    image: "/images/blog-images/hernia.webp",
    date: "2025-03-05",
    author: "Dr. Dileep",
  },
];

export default function BlogPreview() {
  var recentBlogs = BLOGS.slice(0, 3);

  return (
    <section data-testid="blog-preview-section" className="py-16 md:py-24 bg-clinical">
      <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-7xl">
        <div className="flex items-end justify-between mb-12">
          <div>
            <p className="reveal text-teal font-medium text-sm uppercase tracking-widest mb-3">Health Blogs</p>
            <h2 className="reveal delay-1 font-heading font-bold text-3xl md:text-4xl text-navy tracking-tight">
              Your Guide to Better Health
            </h2>
          </div>
          <Link
            to="/blogs"
            data-testid="view-all-blogs-btn"
            className="hidden md:inline-flex items-center gap-1.5 text-teal font-medium text-sm hover:gap-2.5 transition-all"
          >
            View All <ArrowRight className="w-4 h-4" />
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {recentBlogs.map(function(blog, i) {
            return (
              <Link
                key={blog.slug}
                to={"/blogs/" + blog.slug}
                data-testid={"blog-card-" + i}
                className={"reveal delay-" + (i + 1) + " group bg-white rounded-xl border border-slate-100 shadow-sm overflow-hidden hover:shadow-md hover:-translate-y-1 transition-all duration-300"}
              >
                <div className="aspect-video overflow-hidden">
                  <img
                    src={blog.image}
                    alt={blog.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                </div>
                <div className="p-5">
                  <div className="flex items-center gap-3 text-xs text-slate-400 mb-3">
                    <span className="flex items-center gap-1">
                      <Calendar className="w-3 h-3" />
                      {new Date(blog.date).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" })}
                    </span>
                    <span className="flex items-center gap-1">
                      <User className="w-3 h-3" />
                      {blog.author}
                    </span>
                  </div>
                  <h3 className="font-heading font-semibold text-navy text-base mb-2 group-hover:text-teal transition-colors line-clamp-2">
                    {blog.title}
                  </h3>
                  <p className="text-sm text-slate-500 line-clamp-2">{blog.excerpt}</p>
                </div>
              </Link>
            );
          })}
        </div>

        <div className="mt-8 text-center md:hidden">
          <Link to="/blogs" className="inline-flex items-center gap-1.5 text-teal font-medium text-sm">
            View All Blogs <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </div>
    </section>
  );
}
